import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { takeUntil } from 'rxjs';

import { BaseComponent } from '../../../../core/components/base/base.component';
import { OnwardNotice, describeReferralFailure } from '../../../../core/models/referral.model';
import { FeedbackService } from '../../../../core/services/feedback.service';
import { ReferralService } from '../../../../core/services/referral.service';

export interface ReferralOnwardNoticeDialogData {
  noticeId: string;
  groupId: string;
  patientName: string | null;
}

/**
 * An onward referral notice (referrals architecture §19, P9; D7): a practice that accepted this practice's referral
 * referred the patient on. It says who, and nothing clinical; acknowledging removes it from the inbox.
 */
@Component({
  selector: 'app-referral-onward-notice-dialog',
  templateUrl: './referral-onward-notice-dialog.component.html',
  styleUrls: ['../referral-note-review-dialog/referral-note-review-dialog.component.scss'],
})
export class ReferralOnwardNoticeDialogComponent extends BaseComponent implements OnInit {
  notice: OnwardNotice | null = null;
  isLoading = true;
  loadError: string | null = null;
  isSaving = false;
  actionError: string | null = null;

  constructor(
    private referralService: ReferralService,
    private dialogRef: MatDialogRef<ReferralOnwardNoticeDialogComponent, { changed?: boolean }>,
    @Inject(MAT_DIALOG_DATA) public data: ReferralOnwardNoticeDialogData,
    fs: FeedbackService,
    md: MatDialog,
  ) {
    super(fs, md);
  }

  ngOnInit(): void {
    this.referralService.getOnwardNotice(this.data.noticeId, this.data.groupId).pipe(takeUntil(this.destroy$)).subscribe({
      next: (notice) => { this.notice = notice; this.isLoading = false; },
      error: (error) => { this.isLoading = false; this.loadError = describeReferralFailure(error, 'This notice could not be loaded.'); },
    });
  }

  acknowledge(): void {
    if (!this.notice || this.isSaving) return;
    this.isSaving = true;
    this.referralService.acknowledgeOnwardNotice(this.data.noticeId, this.data.groupId).pipe(takeUntil(this.destroy$)).subscribe({
      next: () => { this.isSaving = false; this.dialogRef.close({ changed: true }); },
      error: (error) => { this.isSaving = false; this.actionError = describeReferralFailure(error, 'The notice could not be acknowledged. Please try again.'); },
    });
  }

  close(): void {
    this.dialogRef.close({});
  }
}
